module.exports = __webpack_public_path__ + "static/media/upsell-tab-popular.b391005e.png";